export const EMAIL = 'scglove14@gmail.com';

export const TEL = '+82 (0)55-763-4972';

export const FAX = '+82 (0)55-901-0299';

export const ADDRESS = '429, Munsan-ro, Geumgok-myeon, Jinju-si, Gyeongsangnam-do, Republic of Korea';

export const WEB = 'https://samwha.glover.kr/';
